import React, { Component } from 'react'
import { connect } from 'react-redux';
import { translate } from 'react-multi-lang'

class UserManual extends Component {

    componentDidMount() {
        document.title = this.props.t('homeContent.userManual', { param: 'react' })
    }

    render() {
        return (
            <div className="tab-content" style={{ border: "none" }}>
                <div id="home" className=" tab-pane active">
                    <section className="login-form mt-0">
                        <div className="container">
                            <div className="row boxsizein">
                                <div className="col-md-12 p-0 mx-auto  tab-content border-0 cover-shadow   mb-3 mt-3  ">
                                    <div className="panel-heading">
                                        <h6 className="mb-0">{this.props.t('homeContent.userManual', { param: 'react' })}</h6>
                                    </div>
                                    <div className="panel-body p-policy pt-0 p-3 ">
                                        <h4 className='usermanul'><a href="/docs/Jobseeker_manual.pdf" aria-label={this.props.t('header.jobseekerManual', { param: 'react' })}  target="_blank" role="button" tabIndex="0">{this.props.t('header.jobseekerManual', { param: 'react' })} <span className='pdf-size'> (Pdf, 534.0 kb)</span> </a></h4>
                                        <h4 className='usermanul'><a href="/docs/employer_manual.pdf" aria-label={this.props.t('header.employerManual', { param: 'react' })} target="_blank" role="button" tabIndex="0">{this.props.t('header.employerManual', { param: 'react' })}<span className='pdf-size'> (Pdf, 571.9 kb)</span></a></h4>
                                        <h4 className='usermanul'><a href="/docs/counsellor.pdf" aria-label={this.props.t('header.counsellorManual', { param: 'react' })} target="_blank" role="button" tabIndex="0">{this.props.t('header.counsellorManual', { param: 'react' })}<span className='pdf-size'> (Pdf, 1.1 Mb)</span></a></h4>
                                        <h4 className='usermanul'><a href="/docs/Local-service-provider.pdf" aria-label={this.props.t('header.lspManual', { param: 'react' })} target="_blank" role="button" tabIndex="0">{this.props.t('header.lspManual', { param: 'react' })} <span className='pdf-size'> (Pdf, 1.0 Mb)</span></a></h4>
                                        <h4 className='usermanul'><a href="/docs/Job-Mela-Manual.pdf" aria-label="Job Mela Manual" target="_blank" role="button" tabIndex="0">Job Mela Manual <span className='pdf-size'> (826.9 kb)</span></a></h4>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </section>
                </div>
            </div>
        )
    }
}

const mapStateToProps = store => {
    return store;
};
export default connect(mapStateToProps)(translate(UserManual));
